import React from 'react';
import { Button } from './Button';
import { LockIcon } from 'lucide-react';
export const Hero = () => {
  const scrollToTestimonials = () => {
    const testimonialsSection = document.getElementById('testimonios');
    if (testimonialsSection) {
      testimonialsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section id="inicio" className="bg-gradient-to-b from-orange-50 to-white py-16 md:py-24" data-id="element-229">
      <div className="container mx-auto px-4" data-id="element-230">
        <div className="flex flex-col md:flex-row items-center" data-id="element-231">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-232">
            <div className="flex items-center mb-4 bg-orange-100 w-fit px-4 py-2 rounded-full" data-id="element-233">
              <LockIcon size={16} className="text-orange-600 mr-2" data-id="element-234" />
              <span className="text-orange-800 font-medium text-sm" data-id="element-235">
                Método Exclusivo
              </span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold leading-tight text-gray-900 mb-6" data-id="element-236">
              El Método Prohibido Que Los Gurús Financieros No Quieren Que
              Descubras
            </h1>
            <p className="text-xl md:text-2xl text-gray-700 mb-8 font-medium" data-id="element-237">
              (Porque Solo Funciona en Latinoamérica)
            </p>
            <p className="text-gray-600 mb-8 text-lg" data-id="element-238">
              La primera guía financiera creada para ti, aunque hoy el dinero
              nunca alcance. Deja de seguir reglas extranjeras que nunca
              funcionaron en tu mundo. Porque no es que tú estés fallando… es
              que te entrenaron mal.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-239">
              <Button href="https://jancinas.com/checkouts/cn/hWN5NlkHONW0RzioeC4WJl5d/es-cl?_r=AQAB_muHi4WYbjqTrBznEaayCCMWWHCjPuTB_g6JEDp4-0I&preview_theme_id=186408665457" data-id="element-240">
                Descubrir El Método
              </Button>
              <Button secondary onClick={scrollToTestimonials} data-id="element-241">
                Ver Testimonios
              </Button>
            </div>
          </div>
          <div className="md:w-1/2 md:pl-10" data-id="element-242">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ct88MuYD51yb5kLCPGqKBb/portada_inicio_financiero.png" alt="Tu Nuevo Inicio Financiero - Libro de finanzas para latinoamericanos" className="w-full max-w-md mx-auto rounded-lg shadow-2xl transform hover:-rotate-3 transition-transform duration-300" data-id="element-243" />
          </div>
        </div>
      </div>
    </section>;
};